import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const CampaignZone = React.lazy(() =>
    import('../CampaignZone')
);
const campaignZoneRoutesRegistry = [
    {
        path: PAGE_URL.CAMPAIGN_ZONE_PAGE,
        element: <CampaignZone />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default campaignZoneRoutesRegistry;
